export default {
  UPDATE_DATA_LAYER: 'TAG / UPDATE DATA LAYER',
} as const;
